export const styles = {
  blockingDisclaimer: { margin: '16px 0' },
  checkboxWrapper: { display: 'flex' },
  checkboxLabel: { marginLeft: 16 },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/StatusChange/style.js